export interface OperacaoPendente {
  id: string;
  tipo: 'saque_pix' | 'credito_pontos' | 'debito_pontos' | 'ajuste_saldo' | 'compra_pontos' | 'estorno';
  status: 'pendente' | 'aprovado' | 'rejeitado' | 'processando';
  valor: number;
  valor_formatado: string;
  usuario_nome: string;
  usuario_tipo: 'empresa' | 'participante';
  descricao: string;
  data_solicitacao: string;
  aprovado_por?: string;
  data_aprovacao?: string;
  motivo_rejeicao?: string;
  chave_pix?: string;
  conta_bancaria?: string;
  banco?: string;
}

export const operacoesPendentes: OperacaoPendente[] = [
  {
    id: 'OP-2026-0089',
    tipo: 'saque_pix',
    status: 'pendente',
    valor: 450.0,
    valor_formatado: 'R$ 450,00',
    usuario_nome: 'Roberto Dias',
    usuario_tipo: 'participante',
    descricao: 'Resgate de saldo para conta PIX cadastrada',
    data_solicitacao: '2026-05-05T14:30:00Z',
    chave_pix: 'roberto.dias@email.com',
    banco: 'Itaú'
  },
  {
    id: 'OP-2026-0088',
    tipo: 'saque_pix',
    status: 'pendente',
    valor: 1200.0,
    valor_formatado: 'R$ 1.200,00',
    usuario_nome: 'Marina Oliveira',
    usuario_tipo: 'participante',
    descricao: 'Resgate mensal de bonificação',
    data_solicitacao: '2026-05-06T09:15:00Z',
    chave_pix: '+5511987654321',
    banco: 'Nubank'
  },
  {
    id: 'OP-2026-0087',
    tipo: 'estorno',
    status: 'pendente',
    valor: 2500.0,
    valor_formatado: 'R$ 2.500,00',
    usuario_nome: 'Paulo Henrique',
    usuario_tipo: 'empresa',
    descricao: 'Reembolso de compra de pontos por engano',
    data_solicitacao: '2026-05-08T08:00:00Z',
    conta_bancaria: 'Conta corrente 12345-6 / Agência 7890'
  },
  {
    id: 'OP-2026-0086',
    tipo: 'credito_pontos',
    status: 'pendente',
    valor: 15000,
    valor_formatado: '15.000 pts',
    usuario_nome: 'Consultoria Tech Brasil',
    usuario_tipo: 'empresa',
    descricao: 'Compra de pontos para campanha Q2',
    data_solicitacao: '2026-05-07T16:00:00Z'
  },
  {
    id: 'OP-2026-0085',
    tipo: 'ajuste_saldo',
    status: 'pendente',
    valor: 500,
    valor_formatado: '500 pts',
    usuario_nome: 'João Pedro Silva',
    usuario_tipo: 'participante',
    descricao: 'Ajuste de saldo por erro de pontuação na campanha de abril',
    data_solicitacao: '2026-05-07T11:00:00Z'
  },
  {
    id: 'OP-2026-0084',
    tipo: 'saque_pix',
    status: 'processando',
    valor: 850.0,
    valor_formatado: 'R$ 850,00',
    usuario_nome: 'Carla Mendonça',
    usuario_tipo: 'participante',
    descricao: 'Resgate de bônus de performance',
    data_solicitacao: '2026-05-04T10:00:00Z',
    aprovado_por: 'Carlos Mendes',
    data_aprovacao: '2026-05-05T09:30:00Z',
    chave_pix: 'carla.m@email.com',
    banco: 'Bradesco'
  },
  {
    id: 'OP-2026-0083',
    tipo: 'debito_pontos',
    status: 'rejeitado',
    valor: 2000,
    valor_formatado: '2.000 pts',
    usuario_nome: 'Pedro Lucas',
    usuario_tipo: 'participante',
    descricao: 'Débito de pontos por fraude detectada',
    data_solicitacao: '2026-05-03T13:00:00Z',
    aprovado_por: 'Carlos Mendes',
    data_aprovacao: '2026-05-04T10:00:00Z',
    motivo_rejeicao: 'Não comprovada a fraude. Revertendo operação.'
  },
  {
    id: 'OP-2026-0082',
    tipo: 'saque_pix',
    status: 'aprovado',
    valor: 320.0,
    valor_formatado: 'R$ 320,00',
    usuario_nome: 'Fernanda Lima',
    usuario_tipo: 'participante',
    descricao: 'Resgate de saldo',
    data_solicitacao: '2026-05-02T08:30:00Z',
    aprovado_por: 'Carlos Mendes',
    data_aprovacao: '2026-05-02T14:00:00Z',
    chave_pix: 'fernanda.lima@email.com',
    banco: 'Santander'
  }
];